module.exports = __webpack_public_path__ + "static/home-c7c5318720068b963bf85d8717350779.svg";